class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      })
      .catch(() => {});
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    const drawer = mobileForm && mobileForm.closest('menu-drawer');
    if (drawer) drawer.bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    // Preserve the URL hash (e.g. #size=XXL from the client-side size filter) so
    // sorting and Shopify-facet changes don't silently clear it. Without it,
    // size-filter.js re-reads an empty selection after the grid re-renders and
    // every size shows again.
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}${window.location.hash}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* Custom Sort Dropdown */
(function() {
  function initCustomSortDropdowns() {
    document.querySelectorAll('[data-custom-sort]').forEach(function(dropdown) {
      if (dropdown.dataset.customSortInit) return;
      dropdown.dataset.customSortInit = 'true';

      var trigger = dropdown.querySelector('.custom-sort__trigger');
      var menu = dropdown.querySelector('.custom-sort__menu');
      var overlay = dropdown.querySelector('[data-sort-overlay]');
      var select = dropdown.querySelector('select');
      if (!trigger || !menu || !select) return;

      function open() {
        dropdown.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        if (dropdown.classList.contains('is-open')) {
          close();
        } else {
          // Close any other open dropdowns
          document.querySelectorAll('[data-custom-sort].is-open').forEach(function(d) {
            d.classList.remove('is-open');
            var t = d.querySelector('.custom-sort__trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          });
          open();
        }
      });

      overlay.addEventListener('click', function() { close(); });

      menu.querySelectorAll('.custom-sort__option').forEach(function(option) {
        option.addEventListener('click', function() {
          var value = option.dataset.value;

          // Update visual state
          menu.querySelectorAll('.custom-sort__option').forEach(function(o) {
            o.classList.remove('is-selected');
            o.removeAttribute('aria-selected');
          });
          option.classList.add('is-selected');
          option.setAttribute('aria-selected', 'true');

          // Update trigger text
          var label = option.querySelector('span:last-child');
          trigger.querySelector('.custom-sort__trigger-text').textContent = label ? label.textContent : option.textContent;

          // Update hidden select and trigger form submission. The enclosing
          // form can hold more than one <select name="sort_by"> (a hidden
          // desktop backup + a tablet dropdown), and FormData serializes all
          // of them — so we must set EVERY sort_by select to the chosen value,
          // otherwise the form submits a stale trailing sort_by that the
          // server honors instead (Shopify takes the last value). See sibling
          // filters-panel handler below for the same fix.
          var sortForm = select.closest('form');
          var sortSelects = sortForm
            ? sortForm.querySelectorAll('select[name="sort_by"]')
            : [select];
          sortSelects.forEach(function (s) { s.value = value; });
          select.dispatchEvent(new Event('input', { bubbles: true }));

          close();
        });
      });
    });
  }

  // Close any open custom-sort dropdown on Escape. Registered ONCE at module
  // scope (not per-dropdown) so MutationObserver re-inits don't leak listeners.
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-custom-sort].is-open').forEach(function(d) {
      d.classList.remove('is-open');
      var t = d.querySelector('.custom-sort__trigger');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  });

  // Init on load
  initCustomSortDropdowns();

  // Re-init after AJAX content updates (Shopify facets re-render the DOM)
  var observer = new MutationObserver(function() {
    initCustomSortDropdowns();
    if (window.initFiltersPanels) window.initFiltersPanels();
  });
  var main = document.getElementById('main-collection-product-grid') || document.getElementById('MainContent') || document.body;
  observer.observe(main, { childList: true, subtree: true });
})();

/* Filters Panel */
(function() {
  function initFiltersPanels() {
    document.querySelectorAll('[data-filters-panel]').forEach(function(panel) {
      if (panel.dataset.filtersPanelInit) return;
      panel.dataset.filtersPanelInit = 'true';

      var trigger = panel.querySelector('.filters-panel__trigger');
      var overlay = panel.querySelector('[data-filters-panel-overlay]');
      if (!trigger || !overlay) return;

      function open() {
        panel.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        panel.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        panel.classList.contains('is-open') ? close() : open();
      });

      overlay.addEventListener('click', function() { close(); });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') close();
      });

      // Sort option clicks
      panel.querySelectorAll('.filters-panel__sort-option').forEach(function(option) {
        option.addEventListener('click', function() {
          var value = option.dataset.sortValue;
          var form = panel.closest('form');
          var select = form ? form.querySelector('select[name="sort_by"]') : null;

          // Update visual state
          panel.querySelectorAll('.filters-panel__sort-option').forEach(function(o) {
            o.classList.remove('is-selected');
          });
          option.classList.add('is-selected');

          // Update hidden select and trigger form. The form may contain more
          // than one <select name="sort_by"> (hidden desktop backup + tablet
          // dropdown); FormData serializes them all, so set every one to the
          // chosen value or a stale trailing sort_by wins on the server.
          if (form) {
            form.querySelectorAll('select[name="sort_by"]').forEach(function (s) {
              s.value = value;
            });
          } else if (select) {
            select.value = value;
          }
          if (select) {
            select.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });
      });
    });
  }

  initFiltersPanels();
  window.initFiltersPanels = initFiltersPanels;
})();

/* Mobile sort: keep the server-rendered `is-selected` class in sync with the
   clicked radio so only one row shows a checkmark. The mobile sort details is
   not re-rendered after submit (renderFilters skips the just-clicked filter),
   so we have to clear the stale class ourselves. */
document.addEventListener('change', function(e) {
  const radio = e.target.closest('.mobile-facets__sort-radio');
  if (!radio) return;
  const list = radio.closest('[data-mobile-sort-list]');
  if (!list) return;
  list.querySelectorAll('.mobile-facets__sort-label').forEach((label) => {
    label.classList.remove('is-selected');
  });
  const label = radio.closest('.mobile-facets__sort-label');
  if (label) label.classList.add('is-selected');

  // Close the entire filter/sort drawer after picking a sort. Picking a sort
  // is a one-shot decision, so the drawer should dismiss like Apply does.
  const wrapper = radio.closest('.mobile-facets__wrapper');
  const outerSummary = wrapper && wrapper.querySelector('summary');
  if (outerSummary) outerSummary.click();
});
